import { Button } from '@components/common';
import { Loader2 } from 'lucide-react';
import React from 'react';
import { StockTransferLineItemRow } from './StockTransferLineItemRow';
import { useStockTransferFormContext } from './StockTransferFormContext';

export const StockTransferLineItemsSection: React.FC = () => {
  const {
    form,
    addLine,
    hasAnyInvalidQuantity,
    hasAnyOverAvailable,
    isBalancesLoading,
  } = useStockTransferFormContext();

  return (
    <div>
      <div className="mb-2 flex items-center justify-between">
        <p className="text-sm font-semibold text-black">Items</p>
        <Button variant="text" size="sm" onClick={addLine}>
          + Add item
        </Button>
      </div>
      {hasAnyInvalidQuantity || hasAnyOverAvailable ? (
        <p className="mb-2 rounded-lg bg-red-50 px-3 py-2 text-xs font-medium text-red-600">
          {hasAnyInvalidQuantity
            ? 'Enter a quantity greater than 0 for every selected item.'
            : 'One or more items exceed available stock at the source location.'}
        </p>
      ) : null}
      <div className="max-h-[32rem] overflow-y-auto rounded-xl border border-gray-200">
        <table className="w-full text-sm">
          <thead className="sticky top-0 z-10 bg-gray-50">
            <tr className="text-left">
              <th className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                Item
              </th>
              <th className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                Unit
              </th>
              <th className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                <span className="inline-flex items-center gap-1.5">
                  Available Quantity
                  {isBalancesLoading ? (
                    <>
                      <Loader2
                        size={12}
                        className="animate-spin text-gray-400"
                      />
                      <span className="normal-case text-gray-400">
                        Loading stock levels…
                      </span>
                    </>
                  ) : null}
                </span>
              </th>
              <th className="px-3 py-2 text-xs font-semibold uppercase tracking-wide text-gray-500">
                Quantity
              </th>
            </tr>
          </thead>
          <tbody>
            {form.lines.map((line) => (
              <StockTransferLineItemRow key={line.key} line={line} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
